module.exports = __webpack_public_path__ + "img/gnu_gallery0.728d497e.jpg";